module.exports = __webpack_public_path__ + "img/incein-logo.13bb2cea.png";